export default __webpack_public_path__ + "static/machine-with-sparks-3f3109a569edb971a3848eff9b58a8e8.jpg";